<template>
  <div
    class="tooth"
    v-click-outside="onCloseMenu">
    <tooth-popover-menu
      top
      v-bind:flip="flip"
      v-bind:value="isShowMenu">
      <template slot="trigger">
        <div class="tooth__body">
          <svg
            v-if="!isDeleted"
            class="tooth-down-4 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 72 183">
            <g v-if="isDiagnosisImplant" id="implant">
              <rect width="25.564" height="13.231" x="23.297" y="109.333" fill="#A8BEC5" stroke="#778F9F" rx="1.397" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M46.495 126.424H25.663l4.836 55.777h11.904l4.092-55.777Z" />
              <rect width="29.845" height="4.309" x="-.474" y=".474" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" transform="matrix(1 0 0 -1 21.63 127.373)" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M23 131.082a1.68 1.68 0 0 1 1.938-1.372l23.521 4.032.168.037a1.68 1.68 0 0 1-.736 3.274l-23.52-4.032A1.68 1.68 0 0 1 23 131.082Zm2.433 5.266.17.02 22.176 3.696a1.68 1.68 0 0 1-.552 3.314l-22.176-3.695-.168-.037a1.681 1.681 0 0 1 .55-3.298Zm.339 6.326.172.02 21.84 3.696a1.68 1.68 0 0 1-.561 3.313l-21.84-3.696-.169-.037a1.681 1.681 0 0 1 .558-3.296Zm-.759 7.729a1.68 1.68 0 0 1 1.93-1.387l20.496 3.36a1.68 1.68 0 1 1-.544 3.316l-20.496-3.361a1.679 1.679 0 0 1-1.386-1.928Zm2.142 4.924.17.024 19.153 3.696a1.68 1.68 0 0 1-.636 3.299l-19.154-3.697-.166-.04a1.68 1.68 0 0 1 .633-3.282Zm.671 5.988.17.024 17.472 3.361.168.04a1.681 1.681 0 0 1-.802 3.259l-17.472-3.36-.168-.04a1.681 1.681 0 0 1 .632-3.284Zm.294 6.658.171.02 16.128 2.688a1.68 1.68 0 0 1-.552 3.314l-16.128-2.687-.168-.037a1.681 1.681 0 0 1 .55-3.298Zm.39 6.33.17.025 15.12 3.024.168.041a1.68 1.68 0 0 1-.826 3.253l-15.12-3.024-.168-.041a1.68 1.68 0 0 1 .656-3.278Z" />
            </g>
            <g v-else>
              <path
                d="M24.7554 132.5C24.3394 130.59 25.1303 116.927 24.7554 111.149L48.1339 111.357C47.4406 120.455 44.3319 139.711 43.5 148.512C42.4601 159.513 41.9958 174.367 39.5 178C37.0043 181.632 32.5327 182.047 33.5726 174.99C34.6125 167.932 27.916 152.352 27.5 148.512C27.084 144.672 25.2753 134.887 24.7554 132.5Z"
                v-bind:class="{ selected: isSelected('root_1') }"
                v-bind:fill="partColor['root_1'] || '#FFF'"
                v-on:click="onClick('root_1', $event)"
                v-on:keydown="onClick('root_1', $event)" />
              <path
                d="M39.8494 127.826L39.8693 127.878C40.0074 128.239 40.0373 128.631 39.9585 129.009C37.4756 140.933 37.0873 155.866 36.5034 159.589C36.4507 159.925 36.2716 160.215 36.0192 160.443C35.7682 160.669 35.415 160.814 35.146 160.609C34.895 160.418 34.64 160.03 34.64 159.24C34.64 148.202 34.4973 134.909 33.368 128.673L33.2574 128.011C33.2033 127.688 33.2836 127.356 33.4798 127.093C33.6399 126.879 33.8668 126.724 34.1248 126.653L34.5102 126.546L35.415 126.466L37.2525 126.513L38.334 126.679C38.4636 126.699 38.5915 126.729 38.7168 126.767C39.2372 126.927 39.655 127.318 39.8494 127.826Z"
                v-bind:class="{ selected: isSelected('central_canal') }"
                v-bind:fill="partColor['central_canal'] || '#FF82BE'"
                v-on:click="onClick('central_canal', $event)"
                v-on:keydown="onClick('central_canal', $event)" />
            </g>
            <path
              v-if="!isDiagnosisImplant || hasCrownOnImplant"
              d="M44.7726 90.1913C40.7794 86.0399 37.6738 84.9262 35.802 84.8916C35.6243 84.9376 35.4488 84.9866 35.2754 85.0384C25.1318 88.0729 19.5215 101.639 24.1743 111.149C24.6401 112.101 25.1847 113.041 25.819 113.951C30.5609 120.76 36.0811 119.304 39.3376 118.622C40.8282 117.722 45.3379 115.276 47.5528 111.357C49.9309 107.362 50.0322 102.472 49.7896 100.155C49.6856 98.5979 48.7658 94.3427 44.7726 90.1913Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
          <svg
            v-else-if="isBoneImplant"
            class="tooth-down-4 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 72 183">
            <g id="implant">
              <rect width="25.564" height="13.231" x="23.297" y="109.333" fill="#A8BEC5" stroke="#778F9F" rx="1.397" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M46.495 126.424H25.663l4.836 55.777h11.904l4.092-55.777Z" />
              <rect width="29.845" height="4.309" x="-.474" y=".474" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" transform="matrix(1 0 0 -1 21.63 127.373)" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M23 131.082a1.68 1.68 0 0 1 1.938-1.372l23.521 4.032.168.037a1.68 1.68 0 0 1-.736 3.274l-23.52-4.032A1.68 1.68 0 0 1 23 131.082Zm2.433 5.266.17.02 22.176 3.696a1.68 1.68 0 0 1-.552 3.314l-22.176-3.695-.168-.037a1.681 1.681 0 0 1 .55-3.298Zm.339 6.326.172.02 21.84 3.696a1.68 1.68 0 0 1-.561 3.313l-21.84-3.696-.169-.037a1.681 1.681 0 0 1 .558-3.296Zm-.759 7.729a1.68 1.68 0 0 1 1.93-1.387l20.496 3.36a1.68 1.68 0 1 1-.544 3.316l-20.496-3.361a1.679 1.679 0 0 1-1.386-1.928Zm2.142 4.924.17.024 19.153 3.696a1.68 1.68 0 0 1-.636 3.299l-19.154-3.697-.166-.04a1.68 1.68 0 0 1 .633-3.282Zm.671 5.988.17.024 17.472 3.361.168.04a1.681 1.681 0 0 1-.802 3.259l-17.472-3.36-.168-.04a1.681 1.681 0 0 1 .632-3.284Zm.294 6.658.171.02 16.128 2.688a1.68 1.68 0 0 1-.552 3.314l-16.128-2.687-.168-.037a1.681 1.681 0 0 1 .55-3.298Zm.39 6.33.17.025 15.12 3.024.168.041a1.68 1.68 0 0 1-.826 3.253l-15.12-3.024-.168-.041a1.68 1.68 0 0 1 .656-3.278Z" />
            </g>
            <path
              v-if="hasCrownOnImplant"
              d="M44.7726 90.1913C40.7794 86.0399 37.6738 84.9262 35.802 84.8916C35.6243 84.9376 35.4488 84.9866 35.2754 85.0384C25.1318 88.0729 19.5215 101.639 24.1743 111.149C24.6401 112.101 25.1847 113.041 25.819 113.951C30.5609 120.76 36.0811 119.304 39.3376 118.622C40.8282 117.722 45.3379 115.276 47.5528 111.357C49.9309 107.362 50.0322 102.472 49.7896 100.155C49.6856 98.5979 48.7658 94.3427 44.7726 90.1913Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
          <button
            class="tooth__body__all-tooth"
            type="button"
            v-on:click="onAllToothClick($event)" />
          <button
            class="tooth__body__gingiva"
            type="button"
            v-bind:class="{ selected: isSelected('gingiva') }"
            v-bind:style="{ 'background-color': partColor['gingiva'] || '#f4ddc1' }"
            v-on:click="onClick('gingiva', $event)" />
          <button
            class="tooth__body__bone"
            type="button"
            v-bind:class="{ selected: isSelected('bone') }"
            v-bind:style="{ 'background-color': partColor['bone'] || '#ffead2' }"
            v-on:click="onClick('bone', $event)" />
        </div>
      </template>
      <form-teeth-formula-diagnoses
        v-bind:class="{ 'disable-component': disabled }"
        v-bind:is-deleted="needDeleted"
        v-bind:part-list="partList"
        v-bind:has-implant="hasImplant"
        v-on:cancel="onCloseMenu"
        v-on:change-diagnoses="onChangeDiagnoses"
        v-on:change-tooth-deleted="onChangeToothDeleted"
        v-on:submit="onSubmit" />
    </tooth-popover-menu>
    <bottom-tooth-surface
      v-bind:surface="surface"
      v-bind:part-selected="partSelected"
      v-bind:selected-parts="selectedParts"
      v-bind:flip="flip"
      v-on:select="onClick" />
    <div class="tooth__number">{{ tooth.number }}</div>
  </div>
</template>
<script>
import toothMixin from '@/mixins/toothMixin';
import ToothPopoverMenu from '../ToothPopoverMenu.vue';
import FormTeethFormulaDiagnoses from '../FormTeethFormulaDiagnoses.vue';
import BottomToothSurface from '../BottomToothSurface.vue';

export default {
  components: {
    ToothPopoverMenu,
    FormTeethFormulaDiagnoses,
    BottomToothSurface,
  },
  mixins: [toothMixin],
  name: 'ToothDown4',
};
</script>

<style scoped>
.tooth {
  flex-direction: column-reverse;
}
.tooth__body {
  grid-template-rows: 30px 25px 66px;
}
.tooth__parts {
  top: auto;
  bottom: 17.28px;
}
</style>
